import { Injectable, Optional, SkipSelf } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CanActivate, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { SessionService } from 'src/app/services/session/session.service';
import { CookieDialog } from './cookie-dialog.component';

@Injectable({
    providedIn: 'root',
})
export class GuestGuard implements CanActivate {
    constructor(
        @Optional() @SkipSelf() parentModule: GuestGuard,
        private sessionService: SessionService,
        private router: Router,
        private dialog: MatDialog,
        private translateService: TranslateService
    ) {
        if (parentModule) {
            throw new Error('GuestGuard is already loaded');
        }
    }

    canActivate(): boolean | Observable<boolean> {
        if(this.sessionService.verifyIfCookiesAreAccepted()) {
            const isLoggedIn = this.sessionService.isLogged;

            if (isLoggedIn) {
                // already logged in, go to the home page
                this.router.navigate(['/home']);
            }

            return !isLoggedIn;
        } else {
            this.dialog.open(CookieDialog,{
                data:{
                    message: this.translateService.instant("guard.cookiesMessage"),
                    buttonText: {
                        accept: this.translateService.instant("guard.acceptButton")
                    }
                },
                disableClose: true
            });
            return true;
        }
    }
}
